import { Routes } from '@angular/router';
import { OktaAuthGuard } from '@eda/core/gurads/okta-auth-guard';
import { Main } from '@eda/components/main/main';
import { CallbackComponent } from './components/callback-component/callback-component';

export const routes: Routes = [
  {
    path: 'callback',
    component: CallbackComponent
  },
  {
    path: 'health',
    loadComponent: () => import('@eda/features/health-check/health-check').then(m => m.HealthCheck)
  },
  {
    path: '',
    component: Main,
    canActivate: [OktaAuthGuard]
  }
];
